import { Operation } from '@apollo/client'
import { onError } from '@apollo/client/link/error'
import { UNAUTHORIZED } from 'app/constants'
import { GraphQLFormattedError } from 'graphql'
import { notifyOnUnknownError } from 'shared/utils/notify-on-error'

export const handleRequestErrors = onError(
  ({ graphQLErrors, networkError, operation }) => {
    if (graphQLErrors) {
      for (const error of graphQLErrors) {
        resolveError(error, operation)
      }
    }

    if (networkError) {
      console.error('Network error:', networkError)
    }
  }
)

// NOTE: an Unauthorized error reaches the caller as is; an expired session
// is reported by the gateway itself (see session-expired-link)
const resolveError = (error: GraphQLFormattedError, operation: Operation) => {
  if (error.message === UNAUTHORIZED) return

  if (error.message === 'INTERNAL_SERVER_ERROR') {
    const originalError = error.extensions?.originalError as Error | undefined

    if (originalError?.message === UNAUTHORIZED) return

    if (originalError) notifyOnUnknownError(originalError)
    return
  }

  console.error('Request error', error, operation)
}
